import {fieldTypes} from "./fields";

class Validations {
    static email(value) {
        if (value.length <= 1) return false
        return value.match(/^[^@]+@[^@]+\.[^@]+$/) !== null
    }

    static text(value) {
        return value.length >= 1
    }

    static phone(value) {
        return !!value.match(/^\+?[0-9]+$/) && value.length > 1
    }

    static select(value) {
        return value.length >= 1
    }

    static multySelect(value) {
        console.log(value)
        return value.length >= 1
    }

    static consent(value) {
        return value === true
    }

    static date(value) {
        if (value.length <= 0) return false
        // Validate date format YYYY-MM-DD and that it's a valid date
        const dateRegex = /^\d{4}-\d{2}-\d{2}$/
        if (!dateRegex.test(value)) return false
        const date = new Date(value)
        return date instanceof Date && !isNaN(date) && value === date.toISOString().split('T')[0]
    }

    static forType(type, value) {
        if (type === fieldTypes.EMAIL) return this.email(value)
        if (type === fieldTypes.TEXT) return this.text(value)
        if (type === fieldTypes.PHONE) return this.phone(value)
        if (type === fieldTypes.SELECT) return this.select(value)
        if (type === fieldTypes.MULTY_SELECT) return this.multySelect(value)
        if (type === fieldTypes.CONSENT) return this.consent(value)
        if (type === fieldTypes.DATE) return this.date(value)
        return false
    }

    static isFieldEmpty(type, value) {
        if (typeof value === 'undefined') return true
        switch (type) {
            case fieldTypes.TEXT:
            case fieldTypes.SELECT:
            case fieldTypes.PHONE:
            case fieldTypes.EMAIL:
            case fieldTypes.DATE:
                return value === ''
            case fieldTypes.MULTY_SELECT:
                return value.length === 0
            case fieldTypes.CONSENT:
                return value === false
            default:
                return false
        }
    }
}

export const inputStatus = (type, required, value, isSubmitted = false) => {
  if (!isSubmitted) return null;
  if (!required && Validations.isFieldEmpty(type, value)) return null;
  return Validations.forType(type, value);
}

export const isValidForSubmit = (type, required, value) => {
    if (!required && Validations.isFieldEmpty(type, value)) return true
    return Validations.forType(type, value)
}